import EachComponent from '../../../Components/Entity/EachComponent.component';
// { useState, useEffect }
import React from 'react';
// import SearchCourses from './SearchCoursesComponent.component';
import PropTypes from 'prop-types';
// Results for courses tab on Admin Home Page
const FormsTab = ({ forms, companyId }) => {
  // const [filtered, setFiltered] = useState([]);
  // const [err, setErr] = useState('');

  // setCourses, setSuccessState
  // useEffect(() => {
  //   setFiltered(courses);
  // }, [courses]);

  return (
    <section>
      <h3>FORMS</h3>
      {/* <SearchCourses
        courses={courses}
        setFiltered={setFiltered}
        setErr={setErr}
      /> */}
      {/* {err && <p style={{ color: 'red' }}>{err}</p>} */}
      {/* {successState && <p style={{ color: 'green' }}>{successState}</p>} */}
      {forms?.map((f) => {
        return (
          <EachComponent
            key={f?._id}
            name={f?.name?.replace(/\.pdf$/i, '')}
            route={`/company/${companyId}/edit-form/${f?._id}`}
          />
        );
      })}
      <p>Coming Soon...</p>
    </section>
  );
};
FormsTab.propTypes = {
  forms: PropTypes.array,
  setFiltered: PropTypes.func,
  setErr: PropTypes.func,
  companyId: PropTypes.string,
};

export default FormsTab;
